"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemsMapping = exports.getItemUniqueId = exports.generateItemId = exports.ensureItemIds = exports.defaultNavigationItemList = exports.SortableList = exports.SortableItem = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reactSortableHoc = require("react-sortable-hoc");

var _common = require("@insided/shared/utils/common");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var itemsMapping = {
  community: {
    key: 'community',
    name: 'Community',
    visibility: false,
    hubModuleId: 'Community'
  },
  knowledgeBase: {
    key: 'knowledgeBase',
    name: 'Knowledge Base',
    visibility: false,
    hubModuleId: 'KnowledgeBase'
  },
  ideation: {
    key: 'ideation',
    name: 'Ideation',
    visibility: false,
    url: '/ideas',
    hubModuleId: 'Ideation'
  },
  productUpdates: {
    key: 'productUpdates',
    name: 'Product Updates',
    visibility: false,
    url: '/product-updates',
    hubModuleId: 'ProductUpdates'
  },
  event: {
    key: 'event',
    name: 'Events',
    visibility: false,
    url: '/events',
    hubModuleId: 'Event'
  },
  group: {
    key: 'group',
    name: 'Groups',
    visibility: false,
    url: '/groups',
    hubModuleId: 'Group'
  },
  spaces: {
    key: 'spaces',
    name: 'Spaces',
    visibility: false,
    url: '/spaces',
    hubModuleId: 'Spaces'
  },
  education: {
    key: 'education',
    name: 'Education',
    visibility: false,
    hubModuleId: 'Education'
  },
  custom: {
    key: 'custom',
    name: 'Custom Link',
    visibility: false
  },
  'custom-link': {
    key: 'custom-link',
    name: 'Custom Link',
    visibility: false
  },
  'custom-dropdown': {
    key: 'custom-dropdown',
    name: 'Custom Dropdown',
    visibility: false
  }
};
/**
 * Generate a unique identifier for a navigation item
 * For custom items (key === 'custom'), generates a unique ID based on name and url
 * For other items, uses the key as the ID
 * If item already has an id, returns it
 */

exports.itemsMapping = itemsMapping;

var generateItemId = function generateItemId(item) {
  // If item already has an ID, use it
  if (item.id) {
    return item.id;
  } // For custom items, create a unique ID with just a random suffix
  // This ensures each custom item has a unique identifier that persists even if name/url change


  if (item.key === 'custom-link') {
    var _globalThis$crypto;

    // Use crypto.randomUUID if available, otherwise use timestamp (which is unique)
    var randomSuffix = typeof globalThis !== 'undefined' && (_globalThis$crypto = globalThis.crypto) !== null && _globalThis$crypto !== void 0 && _globalThis$crypto.randomUUID ? globalThis.crypto.randomUUID() : Date.now().toString();
    return "custom:".concat(randomSuffix);
  } // For non-custom items, use the key as the ID


  return item.key;
};
/**
 * Get the unique identifier for an item
 * Uses item.id if available, otherwise falls back to item.key
 * All items should have an id after NavigationLinks ensures IDs are generated
 */


exports.generateItemId = generateItemId;

var getItemUniqueId = function getItemUniqueId(item) {
  var _item$id;

  return (_item$id = item.id) !== null && _item$id !== void 0 ? _item$id : item.key;
};
/**
 * Ensure all items in the array have unique IDs
 * Generates IDs for items that don't have them
 */


exports.getItemUniqueId = getItemUniqueId;

var ensureItemIds = function ensureItemIds(items) {
  return items.map(function (item) {
    if (!item.id) {
      return _objectSpread(_objectSpread({}, item), {}, {
        id: generateItemId(item)
      });
    }

    return item;
  });
};

exports.ensureItemIds = ensureItemIds;
var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref) {
  var children = _ref.children;
  return (0, _preact.h)("ul", {
    className: "sortable-navigation-link-list"
  }, children);
});
exports.SortableList = SortableList;

var CustomLi = function CustomLi(props) {
  return (0, _preact.h)("li", (0, _extends2.default)({}, props, {
    className: "sortable-navigation-link ".concat(props.className || '')
  }));
};

var SortableItem = (0, _reactSortableHoc.SortableElement)(CustomLi);
exports.SortableItem = SortableItem;

var defaultNavigationItemList = function defaultNavigationItemList() {
  var itemList = [{
    key: 'community',
    visibility: true,
    name: 'Community'
  }];

  if (_common.common.isModuleActive('knowledgeBase')) {
    itemList.push(_objectSpread(_objectSpread({}, itemsMapping.knowledgeBase), {}, {
      visibility: true
    }));
  }

  if (_common.common.isModuleActive('ideationV2')) {
    itemList.push(_objectSpread(_objectSpread({}, itemsMapping.ideation), {}, {
      visibility: true
    }));
  }

  if (_common.common.isModuleActive('productUpdates')) {
    itemList.push(_objectSpread(_objectSpread({}, itemsMapping.productUpdates), {}, {
      visibility: true
    }));
  }

  if (_common.common.isModuleActive('event')) {
    itemList.push(_objectSpread(_objectSpread({}, itemsMapping.event), {}, {
      visibility: true
    }));
  }

  if (_common.common.isModuleActive('group')) {
    itemList.push(_objectSpread(_objectSpread({}, itemsMapping.group), {}, {
      visibility: true
    }));
  }

  if (_common.common.isModuleActive('spaces')) {
    itemList.push(_objectSpread({}, itemsMapping.spaces));
  }

  return itemList;
};

exports.defaultNavigationItemList = defaultNavigationItemList;